import {Inject, Injectable, LOCALE_ID} from '@angular/core';
import {ApiService} from "../api/api.service";
import { HttpClient } from '@angular/common/http';
import {
  COUNTRIES_CALLING_CODE_EN_AU,
  COUNTRIES_CALLING_CODE_EN_US,
  COUNTRIES_CALLING_CODE_CA_FR,
  COUNTRIES_CALLING_CODE_ES_US,
  FREQUENT_COUNTRIES_CALLING_CODE_EN_AU,
  FREQUENT_COUNTRIES_CALLING_CODE_EN_US,
  FREQUENT_COUNTRIES_CALLING_CODE_CA_FR,
  FREQUENT_COUNTRIES_CALLING_CODE_ES_US
} from "./constants";

@Injectable({
  providedIn: 'root'
})
export class ConstantsService {

  public static NUM_STAFF_CHOICES = [{'label': $localize`1 - 20`, 'value': '1 - 20'},
    {'label': $localize`21 - 100`, 'value': '21 - 100'},
    {'label': $localize`101 - 500`, 'value': '101 - 500'},
    {'label': $localize`501 - 1000`, 'value': '501 - 1000'},
    {'label': $localize`1001 - 5000`, 'value': '1001 - 5000'},
    {'label': $localize`5001 - 10000`, 'value': '5001 - 10000'},
    {'label': $localize`10000+`, 'value': '10000+'}];

  public static ORG_SIZE_CHOICES = [{'label': $localize`1 - 75`, 'value': '1 - 75'},
    {'label': $localize`76 - 150`, 'value': '76 - 150'},
    {'label': $localize`151 - 300`, 'value': '151 - 300'},
    {'label': $localize`301 - 500`, 'value': '301 - 500'},
    {'label': $localize`501 - 1,000`, 'value': '501 - 1000'},
    {'label': $localize`1,001 - 5,000`, 'value': '1001 - 5000'},
    {'label': $localize`5,001 - 10,000`, 'value': '5001 - 10000'},
    {'label': $localize`10,001+`, 'value': '10001+'}
  ];

  public static ENGAGE_UTM_URL = 'dashboard?src=xref-platform&ltyp=omni&cn=employer-app';
  public static AUTH_TOKEN = 'xrefauthtoken';
  public static REFRESH_TOKEN = 'xrefrefreshtoken';
  public static XREF_ID = 'xrefid';
  public static API_REGION_TOKEN = 'xref-api-region';
  public static DEPRECATED_AUTH_TOKEN = 'xrefauthtoken-sp';
  public static DEPRECATED_REFRESH_TOKEN = 'xrefrefreshtoken-sp';
  public static DEPRECATED_RECRUITER_TOKEN = 'xrefauthtoken';
  public static DEPRECATED_API_REGION_TOKEN = 'xref-api-region-sp';
  public static DEPRECATED_RECRUITER_API_REGION_TOKEN = 'xref-api-region';
  public static ORG_COOKIE = 'xreforgid';
  public static XREF_PLATFORM = 'xref-platform';
  public static XREF_LOCALE = 'xref-chosen-locale';
  public static USERNAME = 'xrefusername';

  // SSO setup
  public static SSO_URLS = {
    OPEN_ID: 'sso/open-id'
  };
  public static SSO_UUID = 'xref-sso-uuid';
  public static SSO_NONCE = 'xref-sso-nonce';
  public static SSO_REDIRECT_URL = 'xref-sso-redirect-url';
  public static SSO_PALTFORM = 'xref-sso-platform';
  public static DEPRECATED_ACCOUNT_MANAGER_CONTACT = 'https://www.xref.com/support?src=xref-platform&ltyp=omni&cn=employer-app&uC2C1gdJ18='
  public static ACCOUNT_MANAGER_CONTACT = 'https://www.xref.com/contact-us?src=xref-platform&ltyp=omni&cn=employer-app&uC2C1gdJ18='
  public static CONTACT_US = 'https://www.xref.com/contact-us';
  public static SIGNUP_CONTACT_XREF_URL = 'https://www.xref.com/contact-us?src=xref-platform&ltyp=omni&cn=employer-app';
  public static SIGNUP_CONTACT_XREF_URL_ENT = 'https://www.xref.com/contact-sales-enterprise-plan?src=xref-platform&ltyp=omni&cn=employer-app';
  public static SIGNUP_PRICING_XREF_URL = 'https://www.xref.com/pricing?src=xref-platform&ltyp=omni&cn=employer-app';

  // CB Plan types
  public static CB_PLAN_SIGN_UP = 'sign_up'
  public static CB_PLAN_SALES_ASSISTED = 'sales_assisted'

  public static DEFAULT_LOGO = "https://xref-assets.xref.com/images/organisation/Group%204324-large.jpeg";
  public static DEBOUNCE_RATE = 350;
  public static DEFAULT_REQUEST_SETTINGS = {
    multipleDaysOrWeeksArray: ['Days', 'Weeks'],
    singleDayOrWeekArray: ['Week', 'Day'],
    minReferenceCount: 1,
    maxReferenceCount: 5,
    minCoverageCount: 1,
    maxCoverageCount: 10,
    maxTimeGapDaysCount: 31,
    minTimeGapDaysCount: 0,
    maxTimeGapWeeksCount: 12,
    minTimeGapWeeksCount: 0
  }
  public static DEFAULT_REFEREE_COUNT = 2;
  public static DEFAULT_MIN_REFEREE_COUNT = 1;
  public static DEFAULT_MAX_REFEREE_COUNT = 5;
  public static CANDIDATE_REFEREE_TEXT_LENGTH = 500;
  public static PDF_EXPORT_SETTINGS = 'pdf-export-settings';
  public static INDUSTRIES = [{
    'label': 'Advertising, Media & Entertainment',
    'value': 'Advertising, Media & Entertainment'
  },
    {'label': $localize`Agriculture`, 'value': 'Agriculture'},
    {'label': $localize`Architecture`, 'value': 'Architecture'},
    {'label': $localize`Call Centre & Customer Services`, 'value': 'Call Centre & Customer Services'},
    {'label': $localize`Construction & Civil Engineering`, 'value': 'Construction & Civil Engineering'},
    {'label': $localize`Defence, Military & Armed Forces`, 'value': 'Defence, Military & Armed Forces'},
    {'label': $localize`Education`, 'value': 'Education'},
    {'label': $localize`Energy`, 'value': 'Energy'},
    {'label': $localize`Engineering`, 'value': 'Engineering'},
    {'label': $localize`Facilities Management`, 'value': 'Facilities Management'},
    {'label': $localize`Finance, Accounting & Banking`, 'value': 'Finance, Accounting & Banking'},
    {'label': $localize`Food & Hospitality`, 'value': 'Food & Hospitality'},
    {'label': $localize`Government - Federal/Central`, 'value': 'Government - Federal/Central'},
    {'label': $localize`Government - Local`, 'value': 'Government - Local'},
    {'label': $localize`Government - State`, 'value': 'Government - State'},
    {'label': $localize`Healthcare & Medical`, 'value': 'Healthcare & Medical'},
    {'label': $localize`HR & Recruitment`, 'value': 'HR & Recruitment'},
    {'label': $localize`Information Technology`, 'value': 'Information Technology'},
    {'label': $localize`Insurance`, 'value': 'Insurance'},
    {'label': $localize`Legal`, 'value': 'Legal'},
    {'label': $localize`Manufacturing`, 'value': 'Manufacturing'},
    {'label': $localize`NFP - Charity`, 'value': 'NFP - Charity'},
    {'label': $localize`NFP - Non-Charity`, 'value': 'NFP - Non-Charity'},
    {'label': $localize`Office & Administration`, 'value': 'Office & Administration'},
    {'label': $localize`Oil & Gas`, 'value': 'Oil & Gas'},
    {'label': $localize`Procurement`, 'value': 'Procurement'},
    {'label': $localize`Professional Services`, 'value': 'Professional Services'},
    {'label': $localize`Property & Real Estate`, 'value': 'Property & Real Estate'},
    {'label': $localize`Resources & Mining`, 'value': 'Resources & Mining'},
    {'label': $localize`Retail & Consumer Products`, 'value': 'Retail & Consumer Products'},
    {'label': $localize`Sales & Marketing`, 'value': 'Sales & Marketing'},
    {'label': $localize`Science, Biotech & Pharmaceuticals`, 'value': 'Science, Biotech & Pharmaceuticals'},
    {'label': $localize`Telecommunications`, 'value': 'Telecommunications'},
    {'label': $localize`Transport & Logistics`, 'value': 'Transport & Logistics'},
    {'label': $localize`Travel & Tourism`, 'value': 'Travel & Tourism'},
    {'label': $localize`Wealth & Investment`, 'value': 'Wealth & Investment'},
    {'label': $localize`Other`, 'value': 'Other'}];

  public static REFEREE_OPT_IN_OUT_DATA = {
    "name": $localize`Referee`,
    "label_1": $localize`Referee opt-in/out`,
    "label_2": $localize`Referee consent to being contacted in relation to reasons provided below.`,
    "label_3": $localize`The referee can only be contacted in relation to the feedback provided.`,
    "label_4": $localize`The organisation requesting this feedback`,
    "label_5": $localize`may in the future want to contact you in relation to potential employment opportunities. Do you consent to being contacted?`,
    "label_6": $localize`may in the future want to contact you in relation to the recruitment needs in your organisation or with potential employment opportunities. Do you consent to being contacted?`,
    "label_7": $localize`for Potential employment opportunities`,
    "label_8": $localize`for Recruitment needs in my organisation`,
    "label_9": $localize`for Recruitment needs in my organisation; Potential employment opportunities`,
    "yes": $localize`Yes`,
    "no": $localize`No`,
    "label_10": $localize`Reference current job title`,
    "label_11": $localize`Reference current organisation`,
    "label_12": $localize`Reference preferred job location`,
    "label_13": $localize`Additional info (e.g. roles you're interested in)`,
    "label_14": $localize`Additional info (e.g. staffing needs, roles you're interested in)`,
    "label_15": $localize`Opt-in`,
    "label_16": $localize`Opt-out`,
    "label_17": $localize`Reference preferred role`,
    "color_1": '#E0EAE7',
     "color_2": '#F7E5E5',
     "color_3": '#32735F',
     "color_4": '#AF0000',
     "color_5": '#2B6251',
  };

  public static REFEREE_SENTIMENT_DATA = {
        "heading": $localize`Reference sentiment`,
        "sub_heading": $localize`This score is calculated automatically and represents feedback sentiment. This should only be considered as a guide.`,
        "block": $localize`Referee`,
        "sentiment_breakdown": $localize`Sentiment breakdown`,
        "positive": $localize`Positive`,
        "neutral": $localize`Neutral`,
        "negative": $localize`Negative`,
    };

  public static UNUSUAL_ACTIVITY_DATA = {
    'header': $localize`Unusual activity detected*`,
    'suspicious_header': $localize`Marked as suspicious by`,
    'show_details': $localize`Show details`,
    'hide_details': $localize`Hide details`,
    'conjunction': $localize`and`,
    'unusual_ip_behaviour': $localize`Unusual IP behaviour`,
    'unusual_email_behaviour': $localize`Unusual email behaviour`,
    'unusual_browser_behaviour': $localize`Unusual operating system and browser behaviour`,
    'unusual_phone_behaviour': $localize`Unusual phone number behaviour`,
    'note': $localize`Notes`,
    'note_placeholder': $localize`Enter a statement`,
    'add_note': $localize`Add`,
    'note_editor': $localize`wrote this`,
    'resolution': $localize`Resolution`,
    'resolution_note': $localize`Before taking any action, or allowing this to impact your hiring decisions, please further investigate the unusual activity detected. To do so, you may wish to: Check the lifecycle for unusual activity, contact the candidate and/or referee directly and/or contact Xref for more information.`,
    'learn_more': $localize`Learn more about unusual activity`,
    'mark_valid': $localize`Mark as valid`,
    'mark_suspicious': $localize`Mark as suspicious`,
    'edit_status': $localize`Edit`,
    'unusual_activity_note': $localize`* Unusual activity alerts are based on data collected and managed by Xref and are intended to alert you to possible suspicious activity. They require further investigation and do not constitute legal advice, recommendations or guidance, and should not be relied upon as such. Hiring decisions should not be based on unusual activity alerts without further investigation.`,
}



  public static QUESTIONNAIRE_LIMIT = [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
  public static DEPRECATED_PULSE_QUESTIONNAIRE_LIMIT = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
  public static PULSE_QUESTIONNAIRE_LIMIT = Array.from({length: 100}, (_, i) => i + 1);
  public static MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

  public static EXITS_RECIPIENTS_LIMIT = 5000;
  public static REFERENCE_RECIPIENTS_LIMIT = 100;
  public static PULSES_RECIPIENTS_LIMIT = 5000;
  public static EXIT_CHECK = 'exit'
  public static REFERENCE_CHECK = 'reference'
  public static PULSE_CHECK = 'pulse'
  public static BACKGROUND_CHECK = 'background-check'
  public static ENTERPRISE_PLATFORM_NAME = 'Xref Enterprise Platform';

  public static REFERENCE_RESTRICTED = $localize`Reference (Restricted)`;
  public static BACKGROUND_CHECK_RESTRICTED = $localize`Background check (Restricted)`;
  public static PULSE_RESTRICTED = $localize`Pulse (Restricted)`;
  public static EXIT_RESTRICTED = $localize`Exit (Restricted)`;
  public static POTENTIAL_CANDIDATE_RESTRICTED = $localize`Feedback (Restricted)`;

  public static REFERENCE_RESTRICTED_TOOLTIP = $localize`Access to the survey used in this request is restricted. Contact a Reference administrator to gain access.`;
  public static PULSE_RESTRICTED_TOOLTIP = $localize`Access to the survey used in this request is restricted. Contact a Pulse administrator to gain access.`;
  public static EXIT_RESTRICTED_TOOLTIP = $localize`Access to the survey used in this request is restricted. Contact an Exit administrator to gain access.`;

  public static REFERENCE_NONE_TOOLTIP = $localize`Contact your Reference administrator to gain access to this feature.`
  public static INTEGRATION_NONE_TOOLTIP = $localize`Contact the Owner to gain access to this feature.`
  public static BACKGROUND_CHECK_NONE_TOOLTIP = $localize`Contact your Background check administrator to gain access to this feature.`
  public static PULSE_CHECK_NONE_TOOLTIP = $localize`Contact your Pulse administrator to gain access to this feature.`
  public static EXIT_CHECK_NONE_TOOLTIP = $localize`Contact your Exit administrator to gain access to this feature.`

  public static maxLength :string=  $localize `The length of role should not exceed more than 255.`
  public static HIRING_ORGANISATION_MAX_LENGTH :string=  $localize `Hiring organisation cannot be more than 100 characters`
  public static REASON_MAX_LENGTH :string=  $localize `Reason cannot be more than 100 characters`
  //Marketplace Checks
  public static ID_ONE_DOC_SHORT_NAME = 'id_one_doc'
  public static ID_TWO_DOCS_SHORT_NAME = 'id_two_docs'
  public static ID_ONE_DOC_DVS_SHORT_NAME = 'id_one_doc_dvs'
  public static ID_TWO_DOCS_DVS_SHORT_NAME = 'id_two_docs_dvs'
  public static ICRC_SHORT_NAME = 'icrc'
  public static ACIC_SHORT_NAME = 'acic'
  public static USCRC_SHORT_NAME = 'uscrc'
  public static CACRC_SHORT_NAME = 'cacrc'
  public static UKDBSC_SHORT_NAME = 'ukdbsc'
  public static UKDSC_SHORT_NAME = 'ukdsc'
  public static QVC_SHORT_NAME = 'qualification_verification'
  public static NCC_PC_SHORT_NAME = 'ncc_police_check'
  public static NCC_MOJ_SHORT_NAME = 'ncc_moj'
  public static NCC_RTW_SHORT_NAME = 'ncc_rtw'
  public static NCC_BANKRUPTCY_SHORT_NAME = 'ncc_bankruptcy'
  public static AML_SHORT_NAME = 'aml'
  public static BANNED_SHORT_NAME = 'banned_persons'
  public static CV_SHORT_NAME = 'credential_verification'
  public static CV_SQ_SHORT_NAME = 'CV_SQ'
  public static CV_HL_SHORT_NAME = 'CV_HL'
  public static EDUV_SHORT_NAME = 'education_verification'
  public static EDUV_SQ_SHORT_NAME = 'EDUV_SQ'
  public static EDUV_HL_SHORT_NAME = 'EDUV_HL'
  public static EMPV_SHORT_NAME = 'employment_verification'
  public static EMPV_CP_SHORT_NAME = 'EMPV_CP'
  public static EMPV_SQ_SHORT_NAME = 'EMPV_SQ'
  public static SMC_SHORT_NAME = 'social_media_check'
  public static EIVC_SHORT_NAME = 'eivc'
  public static WWCC_SHORT_NAME = 'certn_working_with_children_check'
  public static WWCC_NSW_ACT_WARNING = $localize`The Working with Children Check (Australia) is currently unavailable for NSW & ACT. If the recipient selects either location, the background check will be cancelled.`
  public static AU_ENHANCED_PUBLIC_RECORD_CHECK_SHORT_NAME = 'certn_au_enhanced_public_record_check'
  public static DIRECTORSHIP_CHECK_SHORT_NAME = 'certn_directorship_check'
  public static DIRECTORSHIP_COUNTRY_PLACEHOLDER = $localize`Select country`
  public static DIRECTORSHIP_COUNTRIES = [
    { key: 'Australia', value: 'Australia' },
    { key: 'Canada', value: 'Canada' },
    { key: 'China', value: 'China' },
    { key: 'France', value: 'France' },
    { key: 'Germany', value: 'Germany' },
    { key: 'Hong Kong', value: 'Hong Kong' },
    { key: 'India', value: 'India' },
    { key: 'Ireland', value: 'Ireland' },
    { key: 'Japan', value: 'Japan' },
    { key: 'South Korea', value: 'South Korea' },
    { key: 'Netherlands', value: 'Netherlands' },
    { key: 'New Zealand', value: 'New Zealand' },
    { key: 'Singapore', value: 'Singapore' },
    { key: 'Switzerland', value: 'Switzerland' },
    { key: 'United Kingdom', value: 'United Kingdom' },
    { key: 'United States', value: 'United States' },
  ]

  public static USERTYPE_CANDIDATE = 'Candidate'
  public static USERTYPE_REFEREE = 'Referee'
  public static USERTYPE_EMPLOYER = 'Employer'
  public static USERTYPE_EXTERNAL = 'External'

  public static LIFECYCLE_COLORS = ['rgba(0, 134, 214, 0.08)', 'rgba(114, 54, 253, 0.06)', 'rgba(148, 213, 0, 0.2)', 'rgba(0, 134, 214, 0.18)', 'rgba(114, 54, 253, 0.18)', 'rgba(33, 149, 0, 0.22)', 'rgba(0, 0, 150, 0.18)', 'rgba(240, 0, 0, 0.14)', 'rgba(210, 145, 188,0.1)']

  public static COUNTRIES_CALLING_CODE_EN_AU = COUNTRIES_CALLING_CODE_EN_AU;
  public static COUNTRIES_CALLING_CODE_EN_US = COUNTRIES_CALLING_CODE_EN_US
  public static COUNTRIES_CALLING_CODE_CA_FR = COUNTRIES_CALLING_CODE_CA_FR;
  public static COUNTRIES_CALLING_CODE_ES_US = COUNTRIES_CALLING_CODE_ES_US;
  public static COUNTRIES_CALLING_CODE = COUNTRIES_CALLING_CODE_EN_AU;
  public static FREQUENT_COUNTRIES_CALLING_CODE_EN_AU = FREQUENT_COUNTRIES_CALLING_CODE_EN_AU
  public static FREQUENT_COUNTRIES_CALLING_CODE_EN_US = FREQUENT_COUNTRIES_CALLING_CODE_EN_US;
  public static FREQUENT_COUNTRIES_CALLING_CODE_CA_FR = FREQUENT_COUNTRIES_CALLING_CODE_CA_FR;
  public static FREQUENT_COUNTRIES_CALLING_CODE_ES_US = FREQUENT_COUNTRIES_CALLING_CODE_ES_US;
  public static FREQUENT_COUNTRIES_CALLING_CODE = FREQUENT_COUNTRIES_CALLING_CODE_EN_AU;

  public static LANG_LOCALE_MAP: Map<string, string> =
    new Map([
      ["en-au", "EN-AU"],
      ["en-us", "EN-US"],
      ["es-us", "ES-US"],
      ["fr-ca", "FR-CA"]
    ]);

  public static METRICS_ICON_MAP = {
    'Organisational strategy': {
      'label': $localize`Organisational strategy`,
      'metric_green_icon': 'https://assets.xref.com/omni/metrics/Green/organisational-strategy.svg',
      'metric_amber_icon': 'https://assets.xref.com/omni/metrics/Amber/organisational-strategy.svg',
      'metric_red_icon': 'https://assets.xref.com/omni/metrics/Red/organisational-strategy.svg',
      'metric_without_background_amber_icon': 'https://assets.xref.com/omni/metrics_without_background/Amber/organisational-strategy.svg',
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/metrics_without_background/Green/organisational-strategy.svg',
      'metric_without_background_red_icon': 'https://assets.xref.com/omni/metrics_without_background/Red/organisational-strategy.svg'
    },
    'Equality, diversity and inclusion': {
      'label': $localize`Equality, diversity and inclusion`,
      'metric_green_icon': 'https://assets.xref.com/omni/metrics/Green/equality-diversity-inclusion.svg',
      'metric_amber_icon': 'https://assets.xref.com/omni/metrics/Amber/equality-diversity-inclusion.svg',
      'metric_red_icon': 'https://assets.xref.com/omni/metrics/Red/equality-diversity-inclusion.svg',
      'metric_without_background_amber_icon': 'https://assets.xref.com/omni/metrics_without_background/Amber/equality-diversity-inclusion.svg',
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/metrics_without_background/Green/equality-diversity-inclusion.svg',
      'metric_without_background_red_icon': 'https://assets.xref.com/omni/metrics_without_background/Red/equality-diversity-inclusion.svg'
    },
    'Environmental awareness': {
      'label': $localize`Environmental awareness`,
      'metric_green_icon': 'https://assets.xref.com/omni/metrics/Green/environmental-awareness.svg',
      'metric_amber_icon': 'https://assets.xref.com/omni/metrics/Amber/environmental-awareness.svg',
      'metric_red_icon': 'https://assets.xref.com/omni/metrics/Red/environmental-awareness.svg',
      'metric_without_background_amber_icon': 'https://assets.xref.com/omni/metrics_without_background/Amber/environmental-awareness.svg',
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/metrics_without_background/Green/environmental-awareness.svg',
      'metric_without_background_red_icon': 'https://assets.xref.com/omni/metrics_without_background/Red/environmental-awareness.svg'
    },
    'Organisational values': {
      'label': $localize`Organisational values`,
      'metric_green_icon': 'https://assets.xref.com/omni/metrics/Green/organisational-values.svg',
      'metric_amber_icon': 'https://assets.xref.com/omni/metrics/Amber/organisational-values.svg',
      'metric_red_icon': 'https://assets.xref.com/omni/metrics/Red/organisational-values.svg',
      'metric_without_background_amber_icon': 'https://assets.xref.com/omni/metrics_without_background/Amber/organisational-values.svg',
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/metrics_without_background/Green/organisational-values.svg',
      'metric_without_background_red_icon': 'https://assets.xref.com/omni/metrics_without_background/Red/organisational-values.svg'
    },
    'Employer brand': {
      'label': $localize`Employer brand`,
      'metric_green_icon': 'https://assets.xref.com/omni/metrics/Green/employer-brand.svg',
      'metric_amber_icon': 'https://assets.xref.com/omni/metrics/Amber/employer-brand.svg',
      'metric_red_icon': 'https://assets.xref.com/omni/metrics/Red/employer-brand.svg',
      'metric_without_background_amber_icon': 'https://assets.xref.com/omni/metrics_without_background/Amber/employer-brand.svg',
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/metrics_without_background/Green/employer-brand.svg',
      'metric_without_background_red_icon': 'https://assets.xref.com/omni/metrics_without_background/Red/employer-brand.svg'
    },
    'Organisational performance': {
      'label': $localize`Organisational performance`,
      'metric_green_icon': 'https://assets.xref.com/omni/metrics/Green/organisational-performance.svg',
      'metric_amber_icon': 'https://assets.xref.com/omni/metrics/Amber/organisational-performance.svg',
      'metric_red_icon': 'https://assets.xref.com/omni/metrics/Red/organisational-performance.svg',
      'metric_without_background_amber_icon': 'https://assets.xref.com/omni/metrics_without_background/Amber/organisational-performance.svg',
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/metrics_without_background/Green/organisational-performance.svg',
      'metric_without_background_red_icon': 'https://assets.xref.com/omni/metrics_without_background/Red/organisational-performance.svg'
    },
    'Workplace environment': {
      'label': $localize`Workplace environment`,
      'metric_green_icon': 'https://assets.xref.com/omni/metrics/Green/workplace-environment.svg',
      'metric_amber_icon': 'https://assets.xref.com/omni/metrics/Amber/workplace-environment.svg',
      'metric_red_icon': 'https://assets.xref.com/omni/metrics/Red/workplace-environment.svg',
      'metric_without_background_amber_icon': 'https://assets.xref.com/omni/metrics_without_background/Amber/workplace-environment.svg',
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/metrics_without_background/Green/workplace-environment.svg',
      'metric_without_background_red_icon': 'https://assets.xref.com/omni/metrics_without_background/Red/workplace-environment.svg'
    },
    'Workplace culture': {
      'label': $localize`Workplace culture`,
      'metric_green_icon': 'https://assets.xref.com/omni/metrics/Green/workplace-culture.svg',
      'metric_amber_icon': 'https://assets.xref.com/omni/metrics/Amber/workplace-culture.svg',
      'metric_red_icon': 'https://assets.xref.com/omni/metrics/Red/workplace-culture.svg',
      'metric_without_background_amber_icon': 'https://assets.xref.com/omni/metrics_without_background/Amber/workplace-culture.svg',
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/metrics_without_background/Green/workplace-culture.svg',
      'metric_without_background_red_icon': 'https://assets.xref.com/omni/metrics_without_background/Red/workplace-culture.svg'
    },
    'Workplace flexibility': {
      'label': $localize`Workplace flexibility`,
      'metric_green_icon': 'https://assets.xref.com/omni/metrics/Green/workplace-flexibility.svg',
      'metric_amber_icon': 'https://assets.xref.com/omni/metrics/Amber/workplace-flexibility.svg',
      'metric_red_icon': 'https://assets.xref.com/omni/metrics/Red/workplace-flexibility.svg',
      'metric_without_background_amber_icon': 'https://assets.xref.com/omni/metrics_without_background/Amber/workplace-flexibility.svg',
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/metrics_without_background/Green/workplace-flexibility.svg',
      'metric_without_background_red_icon': 'https://assets.xref.com/omni/metrics_without_background/Red/workplace-flexibility.svg'
    },
    'Leadership': {
      'label': $localize`Leadership`,
      'metric_green_icon': 'https://assets.xref.com/omni/metrics/Green/leadership.svg',
      'metric_amber_icon': 'https://assets.xref.com/omni/metrics/Amber/leadership.svg',
      'metric_red_icon': 'https://assets.xref.com/omni/metrics/Red/leadership.svg',
      'metric_without_background_amber_icon': 'https://assets.xref.com/omni/metrics_without_background/Amber/leadership.svg',
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/metrics_without_background/Green/leadership.svg',
      'metric_without_background_red_icon': 'https://assets.xref.com/omni/metrics_without_background/Red/leadership.svg'
    },
    'Health and wellbeing': {
      'label': $localize`Health and wellbeing`,
      'metric_green_icon': 'https://assets.xref.com/omni/metrics/Green/health-wellbeing.svg',
      'metric_amber_icon': 'https://assets.xref.com/omni/metrics/Amber/health-wellbeing.svg',
      'metric_red_icon': 'https://assets.xref.com/omni/metrics/Red/health-wellbeing.svg',
      'metric_without_background_amber_icon': 'https://assets.xref.com/omni/metrics_without_background/Amber/health-wellbeing.svg',
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/metrics_without_background/Green/health-wellbeing.svg',
      'metric_without_background_red_icon': 'https://assets.xref.com/omni/metrics_without_background/Red/health-wellbeing.svg'
    },
    'Performance measurement': {
      'label': $localize`Performance measurement`,
      'metric_green_icon': 'https://assets.xref.com/omni/metrics/Green/performance-measurement.svg',
      'metric_amber_icon': 'https://assets.xref.com/omni/metrics/Amber/performance-measurement.svg',
      'metric_red_icon': 'https://assets.xref.com/omni/metrics/Red/performance-measurement.svg',
      'metric_without_background_amber_icon': 'https://assets.xref.com/omni/metrics_without_background/Amber/performance-measurement.svg',
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/metrics_without_background/Green/performance-measurement.svg',
      'metric_without_background_red_icon': 'https://assets.xref.com/omni/metrics_without_background/Red/performance-measurement.svg'
    },
    'Career development and training': {
      'label': $localize`Career development and training`,
      'metric_green_icon': 'https://assets.xref.com/omni/metrics/Green/career-development-training.svg',
      'metric_amber_icon': 'https://assets.xref.com/omni/metrics/Amber/career-development-training.svg',
      'metric_red_icon': 'https://assets.xref.com/omni/metrics/Red/career-development-training.svg',
      'metric_without_background_amber_icon': 'https://assets.xref.com/omni/metrics_without_background/Amber/career-development-training.svg',
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/metrics_without_background/Green/career-development-training.svg',
      'metric_without_background_red_icon': 'https://assets.xref.com/omni/metrics_without_background/Red/career-development-training.svg'
    },
    'Performance feedback': {
      'label': $localize`Performance feedback`,
      'metric_green_icon': 'https://assets.xref.com/omni/metrics/Green/performance-feedback.svg',
      'metric_amber_icon': 'https://assets.xref.com/omni/metrics/Amber/performance-feedback.svg',
      'metric_red_icon': 'https://assets.xref.com/omni/metrics/Red/performance-feedback.svg',
      'metric_without_background_amber_icon': 'https://assets.xref.com/omni/metrics_without_background/Amber/performance-feedback.svg',
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/metrics_without_background/Green/performance-feedback.svg',
      'metric_without_background_red_icon': 'https://assets.xref.com/omni/metrics_without_background/Red/performance-feedback.svg'
    },
    'Recruitment process': {
      'label': $localize`Recruitment process`,
      'metric_green_icon': 'https://assets.xref.com/omni/metrics/Green/recruitment-process.svg',
      'metric_amber_icon': 'https://assets.xref.com/omni/metrics/Amber/recruitment-process.svg',
      'metric_red_icon': 'https://assets.xref.com/omni/metrics/Red/recruitment-process.svg',
      'metric_without_background_amber_icon': 'https://assets.xref.com/omni/metrics_without_background/Amber/recruitment-process.svg',
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/metrics_without_background/Green/recruitment-process.svg',
      'metric_without_background_red_icon': 'https://assets.xref.com/omni/metrics_without_background/Red/recruitment-process.svg'
    },
    'Salary and benefits': {
      'label': $localize`Salary and benefits`,
      'metric_green_icon': 'https://assets.xref.com/omni/metrics/Green/salary-benefits.svg',
      'metric_amber_icon': 'https://assets.xref.com/omni/metrics/Amber/salary-benefits.svg',
      'metric_red_icon': 'https://assets.xref.com/omni/metrics/Red/salary-benefits.svg',
      'metric_without_background_amber_icon': 'https://assets.xref.com/omni/metrics_without_background/Amber/salary-benefits.svg',
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/metrics_without_background/Green/salary-benefits.svg',
      'metric_without_background_red_icon': 'https://assets.xref.com/omni/metrics_without_background/Red/salary-benefits.svg'
    },
    'Recognition': {
      'label': $localize`Recognition`,
      'metric_green_icon': 'https://assets.xref.com/omni/metrics/Green/recognition.svg',
      'metric_amber_icon': 'https://assets.xref.com/omni/metrics/Amber/recognition.svg',
      'metric_red_icon': 'https://assets.xref.com/omni/metrics/Red/recognition.svg',
      'metric_without_background_amber_icon': 'https://assets.xref.com/omni/metrics_without_background/Amber/recognition.svg',
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/metrics_without_background/Green/recognition.svg',
      'metric_without_background_red_icon': 'https://assets.xref.com/omni/metrics_without_background/Red/recognition.svg'
    },
    'Alignment': {
      'label': $localize`Alignment`,
      'metric_green_icon': 'https://assets.xref.com/omni/metrics/Green/alignment.svg',
      'metric_amber_icon': 'https://assets.xref.com/omni/metrics/Amber/alignment.svg',
      'metric_red_icon': 'https://assets.xref.com/omni/metrics/Red/alignment.svg',
      'metric_without_background_amber_icon': 'https://assets.xref.com/omni/metrics_without_background/Amber/alignment.svg',
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/metrics_without_background/Green/alignment.svg',
      'metric_without_background_red_icon': 'https://assets.xref.com/omni/metrics_without_background/Red/alignment.svg'
    },
    'Change management': {
      'label': $localize`Change Management`,
      'metric_green_icon': 'https://assets.xref.com/omni/metrics/Green/change-management.svg',
      'metric_amber_icon': 'https://assets.xref.com/omni/metrics/Amber/change-management.svg',
      'metric_red_icon': 'https://assets.xref.com/omni/metrics/Red/change-management.svg',
      'metric_without_background_amber_icon': 'https://assets.xref.com/omni/metrics_without_background/Amber/change-management.svg',
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/metrics_without_background/Green/change-management.svg',
      'metric_without_background_red_icon': 'https://assets.xref.com/omni/metrics_without_background/Red/change-management.svg'
    },
    'Code of conduct': {
      'label': $localize`Code of conduct`,
      'metric_green_icon': 'https://assets.xref.com/omni/metrics/Green/code-of-conduct.svg',
      'metric_amber_icon': 'https://assets.xref.com/omni/metrics/Amber/code-of-conduct.svg',
      'metric_red_icon': 'https://assets.xref.com/omni/metrics/Red/code-of-conduct.svg',
      'metric_without_background_amber_icon': 'https://assets.xref.com/omni/metrics_without_background/Amber/code-of-conduct.svg',
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/metrics_without_background/Green/code-of-conduct.svg',
      'metric_without_background_red_icon': 'https://assets.xref.com/omni/metrics_without_background/Red/code-of-conduct.svg'
    },
    'Engagement': {
      'label': $localize`Engagement`,
      'metric_green_icon': 'https://assets.xref.com/omni/metrics/Green/engagement.svg',
      'metric_amber_icon': 'https://assets.xref.com/omni/metrics/Amber/engagement.svg',
      'metric_red_icon': 'https://assets.xref.com/omni/metrics/Red/engagement.svg',
      'metric_without_background_amber_icon': 'https://assets.xref.com/omni/metrics_without_background/Amber/engagement.svg',
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/metrics_without_background/Green/engagement.svg',
      'metric_without_background_red_icon': 'https://assets.xref.com/omni/metrics_without_background/Red/engagement.svg'
    },
    'Ethics': {
      'label': $localize`Ethics`,
      'metric_green_icon': 'https://assets.xref.com/omni/metrics/Green/ethics.svg',
      'metric_amber_icon': 'https://assets.xref.com/omni/metrics/Amber/ethics.svg',
      'metric_red_icon': 'https://assets.xref.com/omni/metrics/Red/ethics.svg',
      'metric_without_background_amber_icon': 'https://assets.xref.com/omni/metrics_without_background/Amber/ethics.svg',
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/metrics_without_background/Green/ethics.svg',
      'metric_without_background_red_icon': 'https://assets.xref.com/omni/metrics_without_background/Red/ethics.svg'
    },
    'Facilities': {
      'label': $localize`Facilities`,
      'metric_green_icon': 'https://assets.xref.com/omni/metrics/Green/facilities.svg',
      'metric_amber_icon': 'https://assets.xref.com/omni/metrics/Amber/facilities.svg',
      'metric_red_icon': 'https://assets.xref.com/omni/metrics/Red/facilities.svg',
      'metric_without_background_amber_icon': 'https://assets.xref.com/omni/metrics_without_background/Amber/facilities.svg',
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/metrics_without_background/Green/facilities.svg',
      'metric_without_background_red_icon': 'https://assets.xref.com/omni/metrics_without_background/Red/facilities.svg'
    },
    'Health and safety': {
      'label': $localize`Health and safety`,
      'metric_green_icon': 'https://assets.xref.com/omni/metrics/Green/health-and-safety.svg',
      'metric_amber_icon': 'https://assets.xref.com/omni/metrics/Amber/health-and-safety.svg',
      'metric_red_icon': 'https://assets.xref.com/omni/metrics/Red/health-and-safety.svg',
      'metric_without_background_amber_icon': 'https://assets.xref.com/omni/metrics_without_background/Amber/health-and-safety.svg',
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/metrics_without_background/Green/health-and-safety.svg',
      'metric_without_background_red_icon': 'https://assets.xref.com/omni/metrics_without_background/Red/health-and-safety.svg'
    },
    'Involvement': {
      'label': $localize`Involvement`,
      'metric_green_icon': 'https://assets.xref.com/omni/metrics/Green/involvement.svg',
      'metric_amber_icon': 'https://assets.xref.com/omni/metrics/Amber/involvement.svg',
      'metric_red_icon': 'https://assets.xref.com/omni/metrics/Red/involvement.svg',
      'metric_without_background_amber_icon': 'https://assets.xref.com/omni/metrics_without_background/Amber/involvement.svg',
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/metrics_without_background/Green/involvement.svg',
      'metric_without_background_red_icon': 'https://assets.xref.com/omni/metrics_without_background/Red/involvement.svg'
    },
    'Processes': {
      'label': $localize`Processes`,
      'metric_green_icon': 'https://assets.xref.com/omni/metrics/Green/processes.svg',
      'metric_amber_icon': 'https://assets.xref.com/omni/metrics/Amber/processes.svg',
      'metric_red_icon': 'https://assets.xref.com/omni/metrics/Red/processes.svg',
      'metric_without_background_amber_icon': 'https://assets.xref.com/omni/metrics_without_background/Amber/processes.svg',
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/metrics_without_background/Green/processes.svg',
      'metric_without_background_red_icon': 'https://assets.xref.com/omni/metrics_without_background/Red/processes.svg'
    },
    'Progress': {
      'label': $localize`Progress`,
      'metric_green_icon': 'https://assets.xref.com/omni/metrics/Green/progress.svg',
      'metric_amber_icon': 'https://assets.xref.com/omni/metrics/Amber/progress.svg',
      'metric_red_icon': 'https://assets.xref.com/omni/metrics/Red/progress.svg',
      'metric_without_background_amber_icon': 'https://assets.xref.com/omni/metrics_without_background/Amber/progress.svg',
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/metrics_without_background/Green/progress.svg',
      'metric_without_background_red_icon': 'https://assets.xref.com/omni/metrics_without_background/Red/progress.svg'
    },
    'Remote or isolated work': {
      'label': $localize`Remote or isolated work`,
      'metric_green_icon': 'https://assets.xref.com/omni/metrics/Green/remote-or-isolated-work.svg',
      'metric_amber_icon': 'https://assets.xref.com/omni/metrics/Amber/remote-or-isolated-work.svg',
      'metric_red_icon': 'https://assets.xref.com/omni/metrics/Red/remote-or-isolated-work.svg',
      'metric_without_background_amber_icon': 'https://assets.xref.com/omni/metrics_without_background/Amber/remote-or-isolated-work.svg',
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/metrics_without_background/Green/remote-or-isolated-work.svg',
      'metric_without_background_red_icon': 'https://assets.xref.com/omni/metrics_without_background/Red/remote-or-isolated-work.svg'
    },
    'Resources': {
      'label': $localize`Resources`,
      'metric_green_icon': 'https://assets.xref.com/omni/metrics/Green/resources.svg',
      'metric_amber_icon': 'https://assets.xref.com/omni/metrics/Amber/resources.svg',
      'metric_red_icon': 'https://assets.xref.com/omni/metrics/Red/resources.svg',
      'metric_without_background_amber_icon': 'https://assets.xref.com/omni/metrics_without_background/Amber/resources.svg',
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/metrics_without_background/Green/resources.svg',
      'metric_without_background_red_icon': 'https://assets.xref.com/omni/metrics_without_background/Red/resources.svg'
    },
    'Respect': {
      'label': $localize`Respect`,
      'metric_green_icon': 'https://assets.xref.com/omni/metrics/Green/respect.svg',
      'metric_amber_icon': 'https://assets.xref.com/omni/metrics/Amber/respect.svg',
      'metric_red_icon': 'https://assets.xref.com/omni/metrics/Red/respect.svg',
      'metric_without_background_amber_icon': 'https://assets.xref.com/omni/metrics_without_background/Amber/respect.svg',
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/metrics_without_background/Green/respect.svg',
      'metric_without_background_red_icon': 'https://assets.xref.com/omni/metrics_without_background/Red/respect.svg'
    },
    'Internal communication': {
      'label': $localize`Internal communication`,
      'metric_green_icon': 'https://assets.xref.com/omni/metrics/Green/internal-communication.svg',
      'metric_amber_icon': 'https://assets.xref.com/omni/metrics/Amber/internal-communication.svg',
      'metric_red_icon': 'https://assets.xref.com/omni/metrics/Red/internal-communication.svg',
      'metric_without_background_amber_icon': 'https://assets.xref.com/omni/metrics_without_background/Amber/internal-communication.svg',
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/metrics_without_background/Green/internal-communication.svg',
      'metric_without_background_red_icon': 'https://assets.xref.com/omni/metrics_without_background/Red/internal-communication.svg'
    },
    'Role-specific': {
      'label': $localize`Role-specific`,
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/shared/role_specific_icon.svg',
    },
    'Personal attributes': {
      'label': $localize`Personal attributes`,
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/shared/personal_attribute_icon.svg',
    },
    'Essential': {
      'label': $localize`Essential`,
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/shared/essential_icon.svg',
    },
    'Right to disconnect': {
      'label': $localize`Right to disconnect`,
      'metric_green_icon': 'https://assets.xref.com/omni/metrics/Green/right-to-disconnect.svg',
      'metric_amber_icon': 'https://assets.xref.com/omni/metrics/Amber/right-to-disconnect.svg',
      'metric_red_icon': 'https://assets.xref.com/omni/metrics/Red/right-to-disconnect.svg',
      'metric_without_background_amber_icon': 'https://assets.xref.com/omni/metrics_without_background/Amber/right-to-disconnect.svg',
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/metrics_without_background/Green/right-to-disconnect.svg',
      'metric_without_background_red_icon': 'https://assets.xref.com/omni/metrics_without_background/Red/right-to-disconnect.svg'
    },
    'Risk reporting': {
      'label': $localize`Risk reporting`,
      'metric_green_icon': 'https://assets.xref.com/omni/metrics/Green/risk-reporting.svg',
      'metric_amber_icon': 'https://assets.xref.com/omni/metrics/Amber/risk-reporting.svg',
      'metric_red_icon': 'https://assets.xref.com/omni/metrics/Red/risk-reporting.svg',
      'metric_without_background_amber_icon': 'https://assets.xref.com/omni/metrics_without_background/Amber/risk-reporting.svg',
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/metrics_without_background/Green/risk-reporting.svg',
      'metric_without_background_red_icon': 'https://assets.xref.com/omni/metrics_without_background/Red/risk-reporting.svg'
    },
    'Role clarity': {
      'label': $localize`Role clarity`,
      'metric_green_icon': 'https://assets.xref.com/omni/metrics/Green/role-clarity.svg',
      'metric_amber_icon': 'https://assets.xref.com/omni/metrics/Amber/role-clarity.svg',
      'metric_red_icon': 'https://assets.xref.com/omni/metrics/Red/role-clarity.svg',
      'metric_without_background_amber_icon': 'https://assets.xref.com/omni/metrics_without_background/Amber/role-clarity.svg',
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/metrics_without_background/Green/role-clarity.svg',
      'metric_without_background_red_icon': 'https://assets.xref.com/omni/metrics_without_background/Red/role-clarity.svg'
    },
    'Supervision': {
      'label': $localize`Supervision`,
      'metric_green_icon': 'https://assets.xref.com/omni/metrics/Green/supervision.svg',
      'metric_amber_icon': 'https://assets.xref.com/omni/metrics/Amber/supervision.svg',
      'metric_red_icon': 'https://assets.xref.com/omni/metrics/Red/supervision.svg',
      'metric_without_background_amber_icon': 'https://assets.xref.com/omni/metrics_without_background/Amber/supervision.svg',
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/metrics_without_background/Green/supervision.svg',
      'metric_without_background_red_icon': 'https://assets.xref.com/omni/metrics_without_background/Red/supervision.svg'
    },
    'Teamwork': {
      'label': $localize`Teamwork`,
      'metric_green_icon': 'https://assets.xref.com/omni/metrics/Green/teamwork.svg',
      'metric_amber_icon': 'https://assets.xref.com/omni/metrics/Amber/teamwork.svg',
      'metric_red_icon': 'https://assets.xref.com/omni/metrics/Red/teamwork.svg',
      'metric_without_background_amber_icon': 'https://assets.xref.com/omni/metrics_without_background/Amber/teamwork.svg',
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/metrics_without_background/Green/teamwork.svg',
      'metric_without_background_red_icon': 'https://assets.xref.com/omni/metrics_without_background/Red/teamwork.svg'
    },
    'Technology': {
      'label': $localize`Technology`,
      'metric_green_icon': 'https://assets.xref.com/omni/metrics/Green/technology.svg',
      'metric_amber_icon': 'https://assets.xref.com/omni/metrics/Amber/technology.svg',
      'metric_red_icon': 'https://assets.xref.com/omni/metrics/Red/technology.svg',
      'metric_without_background_amber_icon': 'https://assets.xref.com/omni/metrics_without_background/Amber/technology.svg',
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/metrics_without_background/Green/technology.svg',
      'metric_without_background_red_icon': 'https://assets.xref.com/omni/metrics_without_background/Red/technology.svg'
    },
    'Vision': {
      'label': $localize`Vision`,
      'metric_green_icon': 'https://assets.xref.com/omni/metrics/Green/vision.svg',
      'metric_amber_icon': 'https://assets.xref.com/omni/metrics/Amber/vision.svg',
      'metric_red_icon': 'https://assets.xref.com/omni/metrics/Red/vision.svg',
      'metric_without_background_amber_icon': 'https://assets.xref.com/omni/metrics_without_background/Amber/vision.svg',
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/metrics_without_background/Green/vision.svg',
      'metric_without_background_red_icon': 'https://assets.xref.com/omni/metrics_without_background/Red/vision.svg'
    },
    'Voice safety': {
      'label': $localize`Voice safety`,
      'metric_green_icon': 'https://assets.xref.com/omni/metrics/Green/voice-safety.svg',
      'metric_amber_icon': 'https://assets.xref.com/omni/metrics/Amber/voice-safety.svg',
      'metric_red_icon': 'https://assets.xref.com/omni/metrics/Red/voice-safety.svg',
      'metric_without_background_amber_icon': 'https://assets.xref.com/omni/metrics_without_background/Amber/voice-safety.svg',
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/metrics_without_background/Green/voice-safety.svg',
      'metric_without_background_red_icon': 'https://assets.xref.com/omni/metrics_without_background/Red/voice-safety.svg'
    },
    'Workload': {
      'label': $localize`Workload`,
      'metric_green_icon': 'https://assets.xref.com/omni/metrics/Green/workload.svg',
      'metric_amber_icon': 'https://assets.xref.com/omni/metrics/Amber/workload.svg',
      'metric_red_icon': 'https://assets.xref.com/omni/metrics/Red/workload.svg',
      'metric_without_background_amber_icon': 'https://assets.xref.com/omni/metrics_without_background/Amber/workload.svg',
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/metrics_without_background/Green/workload.svg',
      'metric_without_background_red_icon': 'https://assets.xref.com/omni/metrics_without_background/Red/workload.svg'
    },
    'Values': {
      'label': $localize`Values`,
      'metric_green_icon': 'https://assets.xref.com/omni/metrics/Green/organisational-values.svg',
      'metric_amber_icon': 'https://assets.xref.com/omni/metrics/Amber/organisational-values.svg',
      'metric_red_icon': 'https://assets.xref.com/omni/metrics/Red/organisational-values.svg',
      'metric_without_background_amber_icon': 'https://assets.xref.com/omni/metrics_without_background/Amber/organisational-values.svg',
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/metrics_without_background/Green/organisational-values.svg',
      'metric_without_background_red_icon': 'https://assets.xref.com/omni/metrics_without_background/Red/organisational-values.svg'
    },
    'Workplace experience': {
      'label': $localize`Workplace experience`,
      'metric_green_icon': 'https://assets.xref.com/omni/metrics/Green/workplace-experience.svg',
      'metric_amber_icon': 'https://assets.xref.com/omni/metrics/Amber/workplace-experience.svg',
      'metric_red_icon': 'https://assets.xref.com/omni/metrics/Red/workplace-experience.svg',
      'metric_without_background_amber_icon': 'https://assets.xref.com/omni/metrics_without_background/Amber/workplace-experience.svg',
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/metrics_without_background/Green/workplace-experience.svg',
      'metric_without_background_red_icon': 'https://assets.xref.com/omni/metrics_without_background/Red/workplace-experience.svg'
    },
    'Flexibility': {
      'label': $localize`Flexibility`,
      'metric_green_icon': 'https://assets.xref.com/omni/metrics/Green/workplace-flexibility.svg',
      'metric_amber_icon': 'https://assets.xref.com/omni/metrics/Amber/workplace-flexibility.svg',
      'metric_red_icon': 'https://assets.xref.com/omni/metrics/Red/workplace-flexibility.svg',
      'metric_without_background_amber_icon': 'https://assets.xref.com/omni/metrics_without_background/Amber/workplace-flexibility.svg',
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/metrics_without_background/Green/workplace-flexibility.svg',
      'metric_without_background_red_icon': 'https://assets.xref.com/omni/metrics_without_background/Red/workplace-flexibility.svg'
    },
    'Culture': {
      'label': $localize`Culture`,
      'metric_green_icon': 'https://assets.xref.com/omni/metrics/Green/workplace-culture.svg',
      'metric_amber_icon': 'https://assets.xref.com/omni/metrics/Amber/workplace-culture.svg',
      'metric_red_icon': 'https://assets.xref.com/omni/metrics/Red/workplace-culture.svg',
      'metric_without_background_amber_icon': 'https://assets.xref.com/omni/metrics_without_background/Amber/workplace-culture.svg',
      'metric_without_background_green_icon': 'https://assets.xref.com/omni/metrics_without_background/Green/workplace-culture.svg',
      'metric_without_background_red_icon': 'https://assets.xref.com/omni/metrics_without_background/Red/workplace-culture.svg'
    },
  };

  public static COMPETENCIES_MAP = {
    1: $localize`Ability to learn`,
    2: $localize`Adaptability and flexibility`,
    3: $localize`Attendance, punctuality and reliability`,
    4: $localize`Attention to detail`,
    5: $localize`Computer literacy`,
    6: $localize`Decision making`,
    7: $localize`Finance management`,
    8: $localize`Health and safety compliance`,
    9: $localize`Honesty and integrity`,
    10: $localize`Initiative`,
    11: $localize`Leadership`,
    12: $localize`Autonomy`,
    13: $localize`Motivation`,
    14: $localize`Organisation and planning`,
    15: $localize`Problem solving`,
    16: $localize`Stakeholder management`,
    17: $localize`Teamwork`,
    18: $localize`Time management`,
    19: $localize`Verbal communication`,
    20: $localize`Written communication`
  };

  public static REFEREE_REPLACE_REASONS = [
    {id: 1, value: $localize`Low quality reference`},
    {id: 2, value: $localize`Low word count`},
    {id: 3, value: $localize`Unsuitable referee`},
    {id: 4, value: $localize`Unusual activity alert`},
    {id: 5, value: $localize`Candidate offering an additional reference`}
  ];

  public static NEW_PULSE_PROFILE_FIELDS = {
    'check recipient': [
      {
        label: $localize`First name`,
        key: 'first_name',
      },
      {
        label: $localize`Last name`,
        key: 'last_name',
      },
      {
        label: $localize`Date added`,
        key: 'created',
      },
      {
        label: $localize`Email`,
        key: 'email',
      },
      {
        label: $localize`Work email`,
        key: 'work_email',
      },
      {
        label: $localize`Mobile`,
        key: 'mobile',
      },
      {
        label: $localize`Location`,
        key: 'location',
      },
      {
        label: $localize`LinkedIn`,
        key: 'linkedin_profile',
      },
      {
        label: $localize`Status`,
        key: 'status',
      },
    ],
    'employee': [
      {
        label: $localize`First name`,
        key: 'first_name',
      },
      {
        label: $localize`Last name`,
        key: 'last_name',
      },
      {
        label: $localize`Date added`,
        key: 'created',
      },
      {
        label: $localize`Email`,
        key: 'email',
      },
      {
        label: $localize`Work email`,
        key: 'work_email',
      },
      {
        label: $localize`Mobile`,
        key: 'mobile',
      },
      {
        label: $localize`Location`,
        key: 'location',
      },
      {
        label: $localize`LinkedIn`,
        key: 'linkedin_profile',
      },
      {
        label: $localize`Department`,
        key: 'department',
      },
      {
        label: $localize`Role`,
        key: 'job_title',
      },
      {
        label: $localize`Tenure`,
        key: 'tenure',
      },
      {
        label: $localize`Status`,
        key: 'status',
      },
      {
        label: `org_department`,
        key: 'org_department',
      },
      {
        label: `employment_start_date`,
        key: 'employment_start_date',
      }
    ],
    'ex-employee': [
      {
        label: $localize`First name`,
        key: 'first_name',
      },
      {
        label: $localize`Last name`,
        key: 'last_name',
      },
      {
        label: $localize`Competencies score`,
        key: 'competencies',
      },
      {
        label: $localize`Rehire status`,
        key: 'rehire_status',
      },
      {
        label: $localize`Contact status`,
        key: 'do_not_contact',
      },
      {
        label: $localize`Date added`,
        key: 'created',
      },
      {
        label: $localize`Email`,
        key: 'email',
      },
      {
        label: $localize`Mobile`,
        key: 'mobile',
      },
      {
        label: $localize`Location`,
        key: 'location',
      },
      {
        label: $localize`LinkedIn`,
        key: 'linkedin_profile',
      },
      {
        label: $localize`Department`,
        key: 'department',
      },
      {
        label: $localize`Role`,
        key: 'job_title',
      },
      {
        label: $localize`Tenure`,
        key: 'tenure',
      },
      {
        label: $localize`Status`,
        key: 'status',
      },
      {
        label: `org_department`,
        key: 'org_department',
      },
      {
        label: `employment_start_date`,
        key: 'employment_start_date',
      },
      {
        label: `employment_end_date`,
        key: 'employment_end_date',
      }
    ],
    'candidate': [
      {
        label: $localize`First name`,
        key: 'first_name',
      },
      {
        label: $localize`Last name`,
        key: 'last_name',
      },
      {
        label: $localize`Competencies score`,
        key: 'competencies',
      },
      {
        label: $localize`Rehire status`,
        key: 'rehire_status',
      },
      {
        label: $localize`Contact status`,
        key: 'do_not_contact',
      },
      {
        label: $localize`Date added`,
        key: 'created',
      },
      {
        label: $localize`Email`,
        key: 'email',
      },
      {
        label: $localize`Mobile`,
        key: 'mobile',
      },
      {
        label: $localize`Location`,
        key: 'location',
      },
      {
        label: $localize`LinkedIn`,
        key: 'linkedin_profile',
      },
      {
        label: $localize`Department`,
        key: 'department',
      },
      {
        label: $localize`Role`,
        key: 'job_title',
      },
      {
        label: $localize`Internal Reference`,
        key: 'internal_reference',
      },
      {
        label: $localize`Tenure`,
        key: 'tenure',
      },
      {
        label: $localize`Status`,
        key: 'status',
      },
      {
        label: `org_department`,
        key: 'org_department',
      }
    ]
  }

  public static NEW_PROFILE_FIELDS = {
    'check recipient': [
      {
        label: $localize`First name`,
        key: 'first_name',
      },
      {
        label: $localize`Last name`,
        key: 'last_name',
      },
      {
        label: $localize`Date added`,
        key: 'created',
      },
      {
        label: $localize`Email`,
        key: 'email',
      },
      {
        label: $localize`Work email`,
        key: 'work_email',
      },
      {
        label: $localize`Mobile`,
        key: 'mobile',
      },
      {
        label: $localize`Location`,
        key: 'location',
      },
      {
        label: $localize`LinkedIn`,
        key: 'linkedin_profile',
      },
      {
        label: $localize`Status`,
        key: 'status',
      },
    ],
    'employee': [
      {
        label: $localize`First name`,
        key: 'first_name',
      },
      {
        label: $localize`Last name`,
        key: 'last_name',
      },
      {
        label: $localize`Date added`,
        key: 'created',
      },
      {
        label: $localize`Email`,
        key: 'email',
      },
      {
        label: $localize`Work email`,
        key: 'work_email',
      },
      {
        label: $localize`Mobile`,
        key: 'mobile',
      },
      {
        label: $localize`Location`,
        key: 'location',
      },
      {
        label: $localize`LinkedIn`,
        key: 'linkedin_profile',
      },
      {
        label: $localize`Department`,
        key: 'department',
      },
      {
        label: $localize`Role`,
        key: 'job_title',
      },
      {
        label: $localize`Tenure`,
        key: 'tenure',
      },
      {
        label: $localize`Status`,
        key: 'status',
      },
      {
        label: `org_department`,
        key: 'org_department',
      },
      {
        label: `employment_start_date`,
        key: 'employment_start_date',
      }
    ],
    'ex-employee': [
      {
        label: $localize`First name`,
        key: 'first_name',
      },
      {
        label: $localize`Last name`,
        key: 'last_name',
      },
      {
        label: $localize`Competencies score`,
        key: 'competencies',
      },
      {
        label: $localize`Rehire status`,
        key: 'rehire_status',
      },
      {
        label: $localize`Contact status`,
        key: 'do_not_contact',
      },
      {
        label: $localize`Date added`,
        key: 'created',
      },
      {
        label: $localize`Email`,
        key: 'email',
      },
      {
        label: $localize`Mobile`,
        key: 'mobile',
      },
      {
        label: $localize`Location`,
        key: 'location',
      },
      {
        label: $localize`LinkedIn`,
        key: 'linkedin_profile',
      },
      {
        label: $localize`Department`,
        key: 'department',
      },
      {
        label: $localize`Role`,
        key: 'job_title',
      },
      {
        label: $localize`Tenure`,
        key: 'tenure',
      },
      {
        label: $localize`Status`,
        key: 'status',
      },
      {
        label: `org_department`,
        key: 'org_department',
      },
      {
        label: `employment_start_date`,
        key: 'employment_start_date',
      },
      {
        label: `employment_end_date`,
        key: 'employment_end_date',
      },
      {
        label: $localize`Organisation`,
        key: 'organisation_name'
      }
    ],
    'candidate': [
      {
        label: $localize`First name`,
        key: 'first_name',
      },
      {
        label: $localize`Last name`,
        key: 'last_name',
      },
      {
        label: $localize`Competencies score`,
        key: 'competencies',
      },
      {
        label: $localize`Rehire status`,
        key: 'rehire_status',
      },
      {
        label: $localize`Contact status`,
        key: 'do_not_contact',
      },
      {
        label: $localize`Date added`,
        key: 'created',
      },
      {
        label: $localize`Email`,
        key: 'email',
      },
      {
        label: $localize`Mobile`,
        key: 'mobile',
      },
      {
        label: $localize`Location`,
        key: 'location',
      },
      {
        label: $localize`LinkedIn`,
        key: 'linkedin_profile',
      },
      {
        label: $localize`Department`,
        key: 'department',
      },
      {
        label: $localize`Tenure`,
        key: 'tenure',
      },
      {
        label: $localize`Status`,
        key: 'status',
      },
      {
        label: `org_department`,
        key: 'org_department',
      },
      {
        label: $localize`Organisation`,
        key: 'organisation_name'
      }
    ],
    'potential candidate': [
      {
        label: $localize`First name`,
        key: 'first_name',
      },
      {
        label: $localize`Last name`,
        key: 'last_name',
      },
      {
        label: $localize`Rehire status`,
        key: 'rehire_status',
      },
      {
        label: $localize`Contact status`,
        key: 'do_not_contact',
      },
      {
        label: $localize`Date added`,
        key: 'created',
      },
      {
        label: $localize`Email`,
        key: 'email',
      },
      {
        label: $localize`Mobile`,
        key: 'mobile',
      },
      {
        label: $localize`Location`,
        key: 'location',
      },
      {
        label: $localize`LinkedIn`,
        key: 'linkedin_profile',
      },
      {
        label: $localize`Department`,
        key: 'department',
      },
      {
        label: $localize`Role`,
        key: 'job_title',
      },
      {
        label: $localize`Tenure`,
        key: 'tenure',
      },
      {
        label: $localize`Status`,
        key: 'status',
      },
      {
        label: `org_department`,
        key: 'org_department',
      },
      {
        label: $localize`Organisation`,
        key: 'organisation_name'
      }
    ]
  }

  public static PULSE_PROFILE_FIELDS = {
    'unspecified': [
      {
        label: $localize`First name`,
        key: 'first_name',
      },
      {
        label: $localize`Last name`,
        key: 'last_name',
      },
      {
        label: $localize`Date added`,
        key: 'created',
      },
      {
        label: $localize`Email`,
        key: 'email',
      },
      {
        label: $localize`Work email`,
        key: 'work_email',
      },
      {
        label: $localize`Mobile`,
        key: 'mobile',
      },
      {
        label: $localize`Location`,
        key: 'location',
      },
      {
        label: $localize`LinkedIn`,
        key: 'linkedin_profile',
      },
      {
        label: $localize`Status`,
        key: 'status',
      },
    ],
    'employee': [
      {
        label: $localize`First name`,
        key: 'first_name',
      },
      {
        label: $localize`Last name`,
        key: 'last_name',
      },
      {
        label: $localize`Date added`,
        key: 'created',
      },
      {
        label: $localize`Email`,
        key: 'email',
      },
      {
        label: $localize`Work email`,
        key: 'work_email',
      },
      {
        label: $localize`Mobile`,
        key: 'mobile',
      },
      {
        label: $localize`Location`,
        key: 'location',
      },
      {
        label: $localize`LinkedIn`,
        key: 'linkedin_profile',
      },
      {
        label: $localize`Department`,
        key: 'department',
      },
      {
        label: $localize`Role`,
        key: 'job_title',
      },
      {
        label: $localize`Tenure`,
        key: 'tenure',
      },
      {
        label: $localize`Status`,
        key: 'status',
      },
      {
        label: `org_department`,
        key: 'org_department',
      },
      {
        label: `employment_start_date`,
        key: 'employment_start_date',
      }
    ],
    'ex-employee': [
      {
        label: $localize`First name`,
        key: 'first_name',
      },
      {
        label: $localize`Last name`,
        key: 'last_name',
      },
      {
        label: $localize`Competencies score`,
        key: 'competencies',
      },
      {
        label: $localize`Rehire status`,
        key: 'rehire_status',
      },
      {
        label: $localize`Contact status`,
        key: 'do_not_contact',
      },
      {
        label: $localize`Date added`,
        key: 'created',
      },
      {
        label: $localize`Email`,
        key: 'email',
      },
      {
        label: $localize`Mobile`,
        key: 'mobile',
      },
      {
        label: $localize`Location`,
        key: 'location',
      },
      {
        label: $localize`LinkedIn`,
        key: 'linkedin_profile',
      },
      {
        label: $localize`Department`,
        key: 'department',
      },
      {
        label: $localize`Role`,
        key: 'job_title',
      },
      {
        label: $localize`Tenure`,
        key: 'tenure',
      },
      {
        label: $localize`Status`,
        key: 'status',
      },
      {
        label: `org_department`,
        key: 'org_department',
      },
      {
        label: `employment_start_date`,
        key: 'employment_start_date',
      },
      {
        label: `employment_end_date`,
        key: 'employment_end_date',
      }
    ],
    'candidate': [
      {
        label: $localize`First name`,
        key: 'first_name',
      },
      {
        label: $localize`Last name`,
        key: 'last_name',
      },
      {
        label: $localize`Competencies score`,
        key: 'competencies',
      },
      {
        label: $localize`Rehire status`,
        key: 'rehire_status',
      },
      {
        label: $localize`Contact status`,
        key: 'do_not_contact',
      },
      {
        label: $localize`Date added`,
        key: 'created',
      },
      {
        label: $localize`Email`,
        key: 'email',
      },
      {
        label: $localize`Mobile`,
        key: 'mobile',
      },
      {
        label: $localize`Location`,
        key: 'location',
      },
      {
        label: $localize`LinkedIn`,
        key: 'linkedin_profile',
      },
      {
        label: $localize`Department`,
        key: 'department',
      },
      {
        label: $localize`Role`,
        key: 'job_title',
      },
      {
        label: $localize`Internal Reference`,
        key: 'internal_reference',
      },
      {
        label: $localize`Tenure`,
        key: 'tenure',
      },
      {
        label: $localize`Status`,
        key: 'status',
      },
      {
        label: `org_department`,
        key: 'org_department',
      }
    ]
  }

  constructor(private api: ApiService,
              private http: HttpClient,
              @Inject(LOCALE_ID) public locale: string) {
    if (locale === 'EN-US') {
      ConstantsService.COUNTRIES_CALLING_CODE = ConstantsService.COUNTRIES_CALLING_CODE_EN_US;
      ConstantsService.FREQUENT_COUNTRIES_CALLING_CODE = ConstantsService.FREQUENT_COUNTRIES_CALLING_CODE_EN_US;
    }  else if (locale === 'FR-CA') {
      ConstantsService.COUNTRIES_CALLING_CODE = ConstantsService.COUNTRIES_CALLING_CODE_CA_FR;
      ConstantsService.FREQUENT_COUNTRIES_CALLING_CODE = ConstantsService.FREQUENT_COUNTRIES_CALLING_CODE_CA_FR;
    } else if (locale === 'ES-US') {
      ConstantsService.COUNTRIES_CALLING_CODE = ConstantsService.COUNTRIES_CALLING_CODE_ES_US;
      ConstantsService.FREQUENT_COUNTRIES_CALLING_CODE = ConstantsService.FREQUENT_COUNTRIES_CALLING_CODE_ES_US;
    } else {
      //  Defaults to EN-AU
    }
  }

  public static TimeHalfHourSpan = [
    {value: $localize`12:00 AM`},
    {value: $localize`12:30 AM`},
    {value: $localize`1:00 AM`},
    {value: $localize`1:30 AM`},
    {value: $localize`2:00 AM`},
    {value: $localize`2:30 AM`},
    {value: $localize`3:00 AM`},
    {value: $localize`3:30 AM`},
    {value: $localize`4:00 AM`},
    {value: $localize`4:30 AM`},
    {value: $localize`5:00 AM`},
    {value: $localize`5:30 AM`},
    {value: $localize`6:00 AM`},
    {value: $localize`6:30 AM`},
    {value: $localize`7:00 AM`},
    {value: $localize`7:30 AM`},
    {value: $localize`8:00 AM`},
    {value: $localize`8:30 AM`},
    {value: $localize`9:00 AM`},
    {value: $localize`9:30 AM`},
    {value: $localize`10:00 AM`},
    {value: $localize`10:30 AM`},
    {value: $localize`11:00 AM`},
    {value: $localize`11:30 AM`},
    {value: $localize`12:00 PM`},
    {value: $localize`12:30 PM`},
    {value: $localize`1:00 PM`},
    {value: $localize`1:30 PM`},
    {value: $localize`2:00 PM`},
    {value: $localize`2:30 PM`},
    {value: $localize`3:00 PM`},
    {value: $localize`3:30 PM`},
    {value: $localize`4:00 PM`},
    {value: $localize`4:30 PM`},
    {value: $localize`5:00 PM`},
    {value: $localize`5:30 PM`},
    {value: $localize`6:00 PM`},
    {value: $localize`6:30 PM`},
    {value: $localize`7:00 PM`},
    {value: $localize`7:30 PM`},
    {value: $localize`8:00 PM`},
    {value: $localize`8:30 PM`},
    {value: $localize`9:00 PM`},
    {value: $localize`9:30 PM`},
    {value: $localize`10:00 PM`},
    {value: $localize`10:30 PM`},
    {value: $localize`11:00 PM`},
    {value: $localize`11:30 PM`}
  ];
  public static CUT_OFF = 'cutOffDate';
  public static SCHEDULE = 'schedule';
  public static LifecycleAction = [
    {value: $localize`Created Xref`},
    {value: $localize`Reviewed`},
    {value: $localize`Confirmed`},
    {value: $localize`Answered`},
    {value: $localize`Unobtainable`},
    {value: $localize`Marked reference as suspicious`},
    {value: $localize`Marked reference as valid`},
    {value: $localize`Notified`},
    {value: $localize`Agreed`},
    {value: $localize`Accessed`},
    {value: $localize`Verified`}
  ]

  public static LifecycleUserType = [
    {value: $localize`Referee`},
    {value: $localize`Candidate`},
    {value: $localize`Employer`},
    {value: $localize`System`},
    {value: $localize`External`},
    {value: $localize`Admin`},
  ]
  public static profileStatus = {
    'Target': $localize`Target`,
    'Potential target': $localize`Potential target`,
    'No target': $localize`No target`,
    'Unknown': $localize`Unknown`,
  }
  public static optedInOptions = [
    {'label': $localize`Candidate`, 'value': 'Candidate'},
    {'label': $localize`Potential candidate`, 'value': 'Potential candidate'},
    {'label': $localize`Ex-employee`, 'value': 'Ex-employee'},
  ];
  public static deprecatedProfileStatus = {
    'Candidate': $localize`Candidate`,
    'Employee': $localize`Employee`,
    'Ex-employee': $localize`Ex-employee`,
  }
  public static profileStatuses = {
    'Candidate': $localize`Candidate`,
    'Employee': $localize`Employee`,
    'Ex-employee': $localize`Ex-employee`,
    'Unspecified': $localize`Unspecified`,
  };
  public static UNSPECIFIED = 'Unspecified';

  public static EMPLOYMENT_SECTOR = [
    {"value": "Academy education"},
    {"value": "Accommodation and food service"},
    {"value": "Administrative and support"},
    {"value": "Agriculture, forestry and fishing"},
    {"value": "Arts and entertainment"},
    {"value": "Central government"},
    {"value": "Child care"},
    {"value": "Construction"},
    {"value": "Drivers"},
    {"value": "Energy and air conditioning"},
    {"value": "Financial and insurance"},
    {"value": "Foster/adoption"},
    {"value": "Further education"},
    {"value": "Higher education"},
    {"value": "Independent education"},
    {"value": "Information and communication"},
    {"value": "Law enforcement and security"},
    {"value": "Leisure, sport and tourism"},
    {"value": "Local government"},
    {"value": "Manufacturing"},
    {"value": "Mining and quarrying"},
    {"value": "NHS"},
    {"value": "Preschool education"},
    {"value": "Primary education"},
    {"value": "Private healthcare"},
    {"value": "Professional, technical"},
    {"value": "Public sector- other"},
    {"value": "Real estate activities"},
    {"value": "Recruitment and HR"},
    {"value": "Retail"},
    {"value": "Secondary education"},
    {"value": "Social care"},
    {"value": "Trade or repair of vehicles"},
    {"value": "Transportation and storage"},
    {"value": "Voluntary/charity"},
    {"value": "Water and waste management"}
  ]

  public static DISTANCE_VALUES_KMS = [10, 50, 100, 200]; // for km
  public static DISTANCE_VALUES_MILES = [5, 25, 50, 100]; // for miles
  public static EMPLOYMENT_TYPE = [
    {"value": "Employment - General", "key": "EMPLOYMENT"}
  ]

  public static EMPLOYMENT_COVERAGE = [
      {"value": "1"},
      {"value": "2"},
      {"value": "3"},
      {"value": "4"},
      {"value": "5"},
      {"value": "6"},
      {"value": "7"},
      {"value": "8"},
      {"value": "9"},
      {"value": "10"},
  ]

  public static EMPLOYMENT_QUANTITY = [
      {"value": "1"},
      {"value": "2"},
      {"value": "3"},
      {"value": "4"},
      {"value": "5"},
      {"value": "6"},
      {"value": "7"}
  ]

  // Centric (Certn) restricted option ranges - TRUST-1101 / TRUST-1175
  public static CENTRIC_EMPLOYMENT_COVERAGE = [
      {"value": "3"},
      {"value": "4"},
      {"value": "5"},
      {"value": "6"},
      {"value": "7"}
  ]

  public static CENTRIC_EMPLOYERS_QUANTITY_MIN = [
      {"value": "1"},
      {"value": "2"}
  ]

  public static CENTRIC_EMPLOYERS_QUANTITY_MAX = [
      {"value": "2"},
      {"value": "3"},
      {"value": "4"},
      {"value": "5"}
  ]

  public static CENTRIC_CREDENTIALS_QUANTITY_MIN = [
      {"value": "1"}
  ]

  public static CENTRIC_CREDENTIALS_QUANTITY_MAX = [
      {"value": "1"},
      {"value": "2"},
      {"value": "3"},
      {"value": "4"},
      {"value": "5"}
  ]

  // Education scope replaces the min/max qualifications flow under Centric.
  // `key` is the verification_type value sent to the vendor (TRUST-1123).
  public static CENTRIC_EDUCATION_SCOPE = [
      {"value": "Highest education", "key": "highest"},
      {"value": "All post-secondary education", "key": "post_secondary"}
  ]

  // Collapse any education scope that is no longer offered to the default
  // (highest education) so stale saved values render and re-save cleanly.
  public static normalizeEducationScope(verificationType?: string | null): string {
    const fallback = 'highest';
    if (!verificationType) {
      return fallback;
    }
    const isSupported = ConstantsService.CENTRIC_EDUCATION_SCOPE.some(
      (option) => option.key === verificationType,
    );
    return isSupported ? verificationType : fallback;
  }

  public static CHECKS_SHORT_NAMES = [
    {
      name: 'International Criminal Record Check',
      short_name: 'icrc'
    },
    {
      name: 'Australian Criminal Intelligence Commission Check',
      short_name: 'acic'
    },
    {

      name: 'US Criminal Record Check',
      short_name: 'uscrc'

    },
    {
      name: 'Canada Criminal Record Check',
      short_name: 'cacrc'
    },
    {
      name: 'UK Basic Disclosure Barring Service Check',
      short_name: 'ukdbsc'
    },
    {
      name: 'UK Basic Disclosure Service Check',
      short_name: 'ukdsc'
    },
    {
      name: 'ID - 1 doc',
      short_name: 'id_one_doc'
    },
    {
      name: 'ID - 2 doc',
      short_name: 'id_two_docs'
    },
    {
      name: 'ID - 1 doc + DVS',
      short_name: 'id_one_doc_dvs'
    },
    {
      name: 'ID - 2 docs + DVS',
      short_name: 'id_two_docs_dvs'
    },
    {
      name: 'MobileID',
      vendor: 'RapidID',
      check_type: 'ID Check',
      available_regions: 'Global',
      flow_names: [],
    },
    {
      name: 'Qualification verification',
      short_name: 'qualification_verification'
    }
  ];

  public static TRUST_MARKET_PLACE_STATUSES = {
    notConnected: 0,
    connectionPending: 1,
    connectionFailed: 2,
    connected: 3,
  }

  public industryOptionsMap = {
    "Advertising, Media & Entertainment": $localize`Advertising, Media & Entertainment`,
    "Agriculture": $localize`Agriculture`,
    "Architecture": $localize`Architecture`,
    "Call Centre & Customer Services": $localize`Call Centre & Customer Services`,
    "Construction & Civil Engineering": $localize`Construction & Civil Engineering`,
    "Defence, Military & Armed Forces": $localize`Defence, Military & Armed Forces`,
    "Education": $localize`Education`,
    "Energy": $localize`Energy`,
    "Engineering": $localize`Engineering`,
    "Facilities Management": $localize`Facilities Management`,
    "Finance, Accounting & Banking": $localize`Finance, Accounting & Banking`,
    "Food & Hospitality": $localize`Food & Hospitality`,
    "Government - Federal/Central": $localize`Government - Federal/Central`,
    "Government - Local": $localize`Government - Local`,
    "Government - State": $localize`Government - State`,
    "Healthcare & Medical": $localize`Healthcare & Medical`,
    "HR & Recruitment": $localize`HR & Recruitment`,
    "Information Technology": $localize`Information Technology`,
    "Insurance": $localize`Insurance`,
    "Legal": $localize`Legal`,
    "Manufacturing": $localize`Manufacturing`,
    "NFP - Charity": $localize`NFP - Charity`,
    "NFP - Non-Charity": $localize`NFP - Non-Charity`,
    "Office & Administration": $localize`Office & Administration`,
    "Oil & Gas": $localize`Oil & Gas`,
    "Procurement": $localize`Procurement`,
    "Professional Services": $localize`Professional Services`,
    "Property & Real Estate": $localize`Property & Real Estate`,
    "Resources & Mining": $localize`Resources & Mining`,
    "Retail & Consumer Products": $localize`Retail & Consumer Products`,
    "Sales & Marketing": $localize`Sales & Marketing`,
    "Science, Biotech & Pharmaceuticals": $localize`Science, Biotech & Pharmaceuticals`,
    "Telecommunications": $localize`Telecommunications`,
    "Transport & Logistics": $localize`Transport & Logistics`,
    "Travel & Tourism": $localize`Travel & Tourism`,
    "Utilities": $localize`Utilities`,
    "Wealth & Investment": $localize`Wealth & Investment`,
    "Other": $localize`Other`
  };

  reasonsMap = {
    'Contract completion': $localize`Contract completion`,
    'Career progression': $localize`Career progression`,
    'Personal reasons': $localize`Personal reasons`,
    'Redundancy': $localize`Redundancy`,
    'Salary': $localize`Salary`,
    'Company environment': $localize`Company environment`,
    'Dismissed': $localize`Dismissed`,
    'Prefer not to say': $localize`Prefer not to say`,
    'Location': $localize`Location`,
    'Flexible work practices': $localize`Flexible work practices`,
    'Workload': $localize`Workload`,
    'Health and Safety': $localize`Health and Safety`,
    'Unsatisfactory work tasks': $localize`Unsatisfactory work tasks`,
    'Retirement/Study': $localize`Retirement/Study`
  };

  public static REFEREE_DETAILS_META_DATA = {
    heading: $localize`Referee Details`,
    description: $localize`Feedback coverage is the shared period of employment.`,
    fieldNamesCol1: [$localize`Reference name`, $localize`Organisation`, $localize`Role`],
    fieldNamesCol2: [$localize`Email address`, $localize`Phone`, $localize`Submission date`],
    fieldNamesCol3: [$localize`Feedback start date`, $localize`Feedback end date`, $localize`Feedback coverage`],
  };

  public static CORE_COMPETENCIES_META_DATA = {
    heading: $localize`Core competencies`,
    subheading: $localize`Ratings are measured against others assessed on this survey.`,
    label_2: $localize`Average`,
    label_3: $localize`Candidate Score`,
    competencyData: {
      averagePlaceholder : $localize`Average score`,
      feedBackPlaceHolder: $localize`Referee feedback`
    },
    average_background_color: '#FBF2E5',
    average_font_color: '#d18400',
    score_font_color: '#FFFFFF',
    score_background_color: '#d18400',
    average_value_font_color: '#d18400'
  };
  public static sortCriteriaReferenceCheck = {

    sortOptions: [
      {
        'key': $localize `Recipient`,
        'value': [
          {'label': $localize `A-Z`, 'sortString': 'text'},
          {'label': $localize `Z-A`, 'sortString': '-text'}
        ]
      },
      {
        'key': $localize `group-end`,
        'value': []
      },
      {
        'key': $localize `Email`,
        'value': [
          {'label': $localize `A-Z`, 'sortString': 'text'},
          {'label': $localize `Z-A`, 'sortString': '-text'}
        ]
      }
    ]
  }
  public static sortCriteriaBackGroundCheck = {
    sortOptions: [
      {
        'key': $localize `Recipient`,
        'value': [
          {'label': $localize `A-Z`, 'sortString': 'text'},
          {'label': $localize `Z-A`, 'sortString': '-text'}
        ]
      },
      {
        'key': $localize `group-end`,
        'value': []
      },
      {
        'key': $localize `Email`,
        'value': [
          {'label': $localize `A-Z`, 'sortString': 'text'},
          {'label': $localize `Z-A`, 'sortString': '-text'}
        ]
      }
    ]
  }
  public static sortCriteriaPulseCheck = {
    sortOptions: [
      {
        'key': $localize `Recipient`,
        'value': [
          {'label': $localize `A-Z`, 'sortString': 'text'},
          {'label': $localize `Z-A`, 'sortString': '-text'}
        ]
      },
      {
        'key': $localize `group-end`,
        'value': []
      },
      {
        'key': $localize `Department`,
        'value': [
          {'label': $localize `A-Z`, 'sortString': 'text'},
          {'label': $localize `Z-A`, 'sortString': '-text'}
        ]
      }
    ]
  }
  public static sortCriteriaExitCheck = {
    sortOptions: [
      {
        'key': $localize `Recipient`,
        'value': [
          {'label': $localize `A-Z`, 'sortString': 'text'},
          {'label': $localize `Z-A`, 'sortString': '-text'}
        ]
      },
      {
        'key': $localize `group-end`,
        'value': []
      },
      {
        'key': $localize `Email`,
        'value': [
          {'label': $localize `A-Z`, 'sortString': 'text'},
          {'label': $localize `Z-A`, 'sortString': '-text'}
        ]
      }, {
        'key': $localize `group-end`,
        'value': []
      },
      {
        'key': $localize `End date`,
        'value': [
          {'label': $localize `Ascending`, 'sortString': 'number'},
          {'label': $localize `Descending`, 'sortString': '-number'}
        ]
      }
    ]
  }

  public static searchTitle = $localize`Sorry, we couldn’t find any results`;
  public static searchDescription = $localize`Try another search term or adjust the filters.`;
  public static searchImg = 'https://assets.xref.com/omni/shared/tmp_console_no_vendors.svg';
  public static PRODUCT_NUMBER_TO_ROLE_MAP = {
    0: $localize`None`,
    1: $localize`Integration user`,
    2: $localize`Administrator`,
    3: $localize`Requestor`,
    4: $localize`Contributor`,
    5: $localize`Analyst`
  };

  public static REQUEST_ACCESS_CARD = {
    'heading': $localize`Request access`,
    'subHeading': $localize`Access this page upon being granted permission.`,
    'buttonText': $localize`Request access`,
  }

  public static rolesPermissionProducts = {
    'pulses':"Pulse",
    'exits':"Exit",
  }

  public static memberOptions = [
    {
      id: 1,
      name: 'References',
      display_name: 'Reference',
      img: 'https://assets.xref.com/omni/shared/new_reference_icon.svg',
      disabledImg:
        'https://assets.xref.com/omni/shared/reference_logo_disabled.svg',
      selected: 'None',
      disabled: false,
      hide: false,
      key: 0,
      filter_key: 'reference'
    },
    {
      id: 2,
      name: 'Pulses',
      display_name: 'Pulse',
      img: 'https://assets.xref.com/omni/shared/pulse_icon.svg',
      disabledImg:
        'https://assets.xref.com/omni/shared/pulse_logo_disabled.svg',
      selected: 'None',
      disabled: false,
      hide: false,
      key: 0,
      filter_key: 'pulse'
    },
    {
      id: 3,
      name: 'Exits',
      display_name: 'Exit',
      img: 'https://assets.xref.com/omni/shared/exit_logo.svg',
      disabledImg: 'https://assets.xref.com/omni/shared/exit_logo_disabled.svg',
      selected: 'None',
      disabled: false,
      hide: false,
      key: 0,
      filter_key: 'exit'
    },
    {
      id: 4,
      name: 'Background Checks',
      display_name: 'Background check',
      img: 'https://assets.xref.com/omni/shared/background_check.svg',
      disabledImg:
        'https://assets.xref.com/omni/shared/background_check_logo_disabled.svg',
      selected: 'None',
      disabled: false,
      hide: false,
      key: 0,
      filter_key: 'background_check'
    },
    {
      id: 5,
      name: 'Integrations',
      display_name: 'Integration',
      img: 'https://assets.xref.com/omni/shared/integration_logo.svg',
      disabledImg:
        'https://assets.xref.com/omni/shared/integration_logo_disabled.svg',
      selected: 'None',
      disabled: false,
      hide: false,
      key: 0,
      filter_key: 'integration'
    },
  ];

  public static getMemberOptions() {
    return ConstantsService.memberOptions.map(option => ({ ...option }));
  }

  public static memberRolesValue = {
    0: 'None',
    1: 'Integration user',
    2: 'Administrator',
    3: 'Requestor',
    4: 'Contributor',
    5: 'Analyst',
  }

  public static memberRoleKeyValue = {
    'None': 0,
    'Integration user': 1,
    'Administrator': 2,
    'Requestor': 3,
    'Contributor': 4,
    'Analyst': 5
  }

  public static memberRolePlaceHolders = {
    [$localize`None`]: $localize`None`,
    [$localize`Integration user`]: $localize`Integration user`,
    [$localize`Administrator`]: $localize`Administrator`,
    [$localize`Requestor`]: $localize`Requestor`,
    [$localize`Contributor`]: $localize`Contributor`,
    [$localize`Analyst`]: $localize`Analyst`
  }

  public static DEFAULT_ROLES = {
    'References': $localize`None`,
    'Exits': $localize`None`,
    'Pulses': $localize`None`,
    'Background Checks': $localize`None`,
    'Integrations': $localize`None`,
  }

  public static DEFAULT_ROLES_LOCALISED = {
    'References': $localize`Reference`,
    'Pulses': $localize`Pulse`,
    'Exits': $localize`Exit`,
    'Background Checks': $localize`Background check`,
    'Integrations': $localize`Integration`,
  }

  public static REQUEST_SELECTED_TABS = {
    'reference': $localize`Reference`,
    'exit': $localize`Exit`,
    'pulse': $localize`Pulse`,
    'backGroundCheck': $localize`Background check`,
  }
  public static PRODUCT_ROLE_PREFIXES: { [key: string]: string } = {
    'References': 'reference_',
    'Exits': 'exit_',
    'Background Checks': 'backgroundcheck_',
    'Pulses': 'pulse_',
    'Integrations': 'integration_user_',
  }

  public static ROLE_PERMISSION_MAPPING: { [key: number]: string } = {
    0: 'none',
    1: '',
    2: 'administrator',
    3: 'requestor',
    4: 'contributor',
    5: 'analyst',
  }

  public static COUNTRY_ALPHA_CODES = [
    {name:"Afghanistan", value:"AF"},
    {name:"Åland Islands", value:"AX"},
    {name:"Albania", value:"AL"},
    {name:"Algeria", value:"DZ"},
    {name:"American Samoa", value:"AS"},
    {name:"Andorra", value:"AD"},
    {name:"Angola", value:"AO"},
    {name:"Anguilla", value:"AI"},
    {name:"Antarctica", value:"AQ"},
    {name:"Antigua and Barbuda", value:"AG"},
    {name:"Argentina", value:"AR"},
    {name:"Armenia", value:"AM"},
    {name:"Aruba", value:"AW"},
    {name:"Australia", value:"AU"},
    {name:"Austria", value:"AT"},
    {name:"Azerbaijan", value:"AZ"},
    {name:"Bahamas (the)", value:"BS"},
    {name:"Bahrain", value:"BH"},
    {name:"Bangladesh", value:"BD"},
    {name:"Barbados", value:"BB"},
    {name:"Belarus", value:"BY"},
    {name:"Belgium", value:"BE"},
    {name:"Belize", value:"BZ"},
    {name:"Benin", value:"BJ"},
    {name:"Bermuda", value:"BM"},
    {name:"Bhutan", value:"BT"},
    {name:"Bolivia (Plurinational State of)", value:"BO"},
    {name:"Bonaire, Sint Eustatius and Saba", value:"BQ"},
    {name:"Bosnia and Herzegovina", value:"BA"},
    {name:"Botswana", value:"BW"},
    {name:"Bouvet Island", value:"BV"},
    {name:"Brazil", value:"BR"},
    {name:"British Indian Ocean Territory (the)", value:"IO"},
    {name:"Brunei Darussalam", value:"BN"},
    {name:"Bulgaria", value:"BG"},
    {name:"Burkina Faso", value:"BF"},
    {name:"Burundi", value:"BI"},
    {name:"Cabo Verde", value:"CV"},
    {name:"Cambodia", value:"KH"},
    {name:"Cameroon", value:"CM"},
    {name:"Canada", value:"CA"},
    {name:"Cayman Islands (the)", value:"KY"},
    {name:"Central African Republic (the)", value:"CF"},
    {name:"Chad", value:"TD"},
    {name:"Chile", value:"CL"},
    {name:"China", value:"CN"},
    {name:"Christmas Island", value:"CX"},
    {name:"Cocos (Keeling) Islands (the)", value:"CC"},
    {name:"Colombia", value:"CO"},
    {name:"Comoros (the)", value:"KM"},
    {name:"Congo (the Democratic Republic of the)", value:"CD"},
    {name:"Congo (the)", value:"CG"},
    {name:"Cook Islands (the)", value:"CK"},
    {name:"Costa Rica", value:"CR"},
    {name:"Côte d'Ivoire", value:"CI"},
    {name:"Croatia", value:"HR"},
    {name:"Cuba", value:"CU"},
    {name:"Curaçao", value:"CW"},
    {name:"Cyprus", value:"CY"},
    {name:"Czechia", value:"CZ"},
    {name:"Denmark", value:"DK"},
    {name:"Djibouti", value:"DJ"},
    {name:"Dominica", value:"DM"},
    {name:"Dominican Republic (the)", value:"DO"},
    {name:"Ecuador", value:"EC"},
    {name:"Egypt", value:"EG"},
    {name:"El Salvador", value:"SV"},
    {name:"Equatorial Guinea", value:"GQ"},
    {name:"Eritrea", value:"ER"},
    {name:"Estonia", value:"EE"},
    {name:"Eswatini", value:"SZ"},
    {name:"Ethiopia", value:"ET"},
    {name:"Falkland Islands (the) [Malvinas]", value:"FK"},
    {name:"Faroe Islands (the)", value:"FO"},
    {name:"Fiji", value:"FJ"},
    {name:"Finland", value:"FI"},
    {name:"France", value:"FR"},
    {name:"French Guiana", value:"GF"},
    {name:"French Polynesia", value:"PF"},
    {name:"French Southern Territories (the)", value:"TF"},
    {name:"Gabon", value:"GA"},
    {name:"Gambia (the)", value:"GM"},
    {name:"Georgia", value:"GE"},
    {name:"Germany", value:"DE"},
    {name:"Ghana", value:"GH"},
    {name:"Gibraltar", value:"GI"},
    {name:"Greece", value:"GR"},
    {name:"Greenland", value:"GL"},
    {name:"Grenada", value:"GD"},
    {name:"Guadeloupe", value:"GP"},
    {name:"Guam", value:"GU"},
    {name:"Guatemala", value:"GT"},
    {name:"Guernsey", value:"GG"},
    {name:"Guinea", value:"GN"},
    {name:"Guinea-Bissau", value:"GW"},
    {name:"Guyana", value:"GY"},
    {name:"Haiti", value:"HT"},
    {name:"Heard Island and McDonald Islands", value:"HM"},
    {name:"Holy See (the)", value:"VA"},
    {name:"Honduras", value:"HN"},
    {name:"Hong Kong", value:"HK"},
    {name:"Hungary", value:"HU"},
    {name:"Iceland", value:"IS"},
    {name:"India", value:"IN"},
    {name:"Indonesia", value:"ID"},
    {name:"Iran (Islamic Republic of)", value:"IR"},
    {name:"Iraq", value:"IQ"},
    {name:"Ireland", value:"IE"},
    {name:"Isle of Man", value:"IM"},
    {name:"Israel", value:"IL"},
    {name:"Italy", value:"IT"},
    {name:"Jamaica", value:"JM"},
    {name:"Japan", value:"JP"},
    {name:"Jersey", value:"JE"},
    {name:"Jordan", value:"JO"},
    {name:"Kazakhstan", value:"KZ"},
    {name:"Kenya", value:"KE"},
    {name:"Kiribati", value:"KI"},
    {name:"Korea (the Democratic People's Republic of)", value:"KP"},
    {name:"Korea (the Republic of)", value:"KR"},
    {name:"Kuwait", value:"KW"},
    {name:"Kyrgyzstan", value:"KG"},
    {name:"Lao People's Democratic Republic (the)", value:"LA"},
    {name:"Latvia", value:"LV"},
    {name:"Lebanon", value:"LB"},
    {name:"Lesotho", value:"LS"},
    {name:"Liberia", value:"LR"},
    {name:"Libya", value:"LY"},
    {name:"Liechtenstein", value:"LI"},
    {name:"Lithuania", value:"LT"},
    {name:"Luxembourg", value:"LU"},
    {name:"Macao", value:"MO"},
    {name:"Madagascar", value:"MG"},
    {name:"Malawi", value:"MW"},
    {name:"Malaysia", value:"MY"},
    {name:"Maldives", value:"MV"},
    {name:"Mali", value:"ML"},
    {name:"Malta", value:"MT"},
    {name:"Marshall Islands (the)", value:"MH"},
    {name:"Martinique", value:"MQ"},
    {name:"Mauritania", value:"MR"},
    {name:"Mauritius", value:"MU"},
    {name:"Mayotte", value:"YT"},
    {name:"Mexico", value:"MX"},
    {name:"Micronesia (Federated States of)", value:"FM"},
    {name:"Moldova (the Republic of)", value:"MD"},
    {name:"Monaco", value:"MC"},
    {name:"Mongolia", value:"MN"},
    {name:"Montenegro", value:"ME"},
    {name:"Montserrat", value:"MS"},
    {name:"Morocco", value:"MA"},
    {name:"Mozambique", value:"MZ"},
    {name:"Myanmar", value:"MM"},
    {name:"Namibia", value:"NA"},
    {name:"Nauru", value:"NR"},
    {name:"Nepal", value:"NP"},
    {name:"Netherlands (the)", value:"NL"},
    {name:"New Caledonia", value:"NC"},
    {name:"New Zealand", value:"NZ"},
    {name:"Nicaragua", value:"NI"},
    {name:"Niger (the)", value:"NE"},
    {name:"Nigeria", value:"NG"},
    {name:"Niue", value:"NU"},
    {name:"Norfolk Island", value:"NF"},
    {name:"North Macedonia", value:"MK"},
    {name:"Northern Mariana Islands (the)", value:"MP"},
    {name:"Norway", value:"NO"},
    {name:"Oman", value:"OM"},
    {name:"Pakistan", value:"PK"},
    {name:"Palau", value:"PW"},
    {name:"Palestine, State of", value:"PS"},
    {name:"Panama", value:"PA"},
    {name:"Papua New Guinea", value:"PG"},
    {name:"Paraguay", value:"PY"},
    {name:"Peru", value:"PE"},
    {name:"Philippines (the)", value:"PH"},
    {name:"Pitcairn", value:"PN"},
    {name:"Poland", value:"PL"},
    {name:"Portugal", value:"PT"},
    {name:"Puerto Rico", value:"PR"},
    {name:"Qatar", value:"QA"},
    {name:"Réunion", value:"RE"},
    {name:"Romania", value:"RO"},
    {name:"Russian Federation (the)", value:"RU"},
    {name:"Rwanda", value:"RW"},
    {name:"Saint Barthélemy", value:"BL"},
    {name:"Saint Helena, Ascension and Tristan da Cunha", value:"SH"},
    {name:"Saint Kitts and Nevis", value:"KN"},
    {name:"Saint Lucia", value:"LC"},
    {name:"Saint Martin (French part)", value:"MF"},
    {name:"Saint Pierre and Miquelon", value:"PM"},
    {name:"Saint Vincent and the Grenadines", value:"VC"},
    {name:"Samoa", value:"WS"},
    {name:"Saudi Arabia", value:"SA"},
    {name:"Senegal", value:"SN"},
    {name:"Serbia", value:"RS"},
    {name:"Seychelles", value:"SC"},
    {name:"Sierra Leone", value:"SL"},
    {name:"Singapore", value:"SG"},
    {name:"Sint Maarten (Dutch part)", value:"SX"},
    {name:"Slovakia", value:"SK"},
    {name:"Slovenia", value:"SI"},
    {name:"Solomon Islands", value:"SB"},
    {name:"Somalia", value:"SO"},
    {name:"South Africa", value:"ZA"},
    {name:"South Georgia and the South Sandwich Islands", value:"GS"},
    {name:"South Sudan", value:"SS"},
    {name:"Spain", value:"ES"},
    {name:"Sri Lanka", value:"LK"},
    {name:"Sudan (the)", value:"SD"},
    {name:"Suriname", value:"SR"},
    {name:"Svalbard and Jan Mayen", value:"SJ"},
    {name:"Sweden", value:"SE"},
    {name:"Switzerland", value:"CH"},
    {name:"Syrian Arab Republic (the)", value:"SY"},
    {name:"Taiwan (Province of China)", value:"TW"},
    {name:"Tajikistan", value:"TJ"},
    {name:"Tanzania, the United Republic of", value:"TZ"},
    {name:"Thailand", value:"TH"},
    {name:"Timor-Leste", value:"TL"},
    {name:"Togo", value:"TG"},
    {name:"Tokelau", value:"TK"},
    {name:"Tonga", value:"TO"},
    {name:"Trinidad and Tobago", value:"TT"},
    {name:"Tunisia", value:"TN"},
    {name:"Turvalue", value:"TR"},
    {name:"Turkmenistan", value:"TM"},
    {name:"Turks and Caicos Islands (the)", value:"TC"},
    {name:"Tuvalu", value:"TV"},
    {name:"Uganda",	value:"UG"},
    {name:"Ukraine", value:"UA"},
    {name:"United Arab Emirates (the)", value:"AE"},
    {name:"United Kingdom of Great Britain and Northern Ireland (the)", value:"GB"},
    {name:"United States Minor Outlying Islands (the)", value:"UM"},
    {name:"United States of America (the)", value:"US"},
    {name:"Uruguay", value:"UY"},
    {name:"Uzbekistan", value:"UZ"},
    {name:"Vanuatu", value:"VU"},
    {name:"Venezuela (Bolivarian Republic of)", value:"VE"},
    {name:"Viet Nam", value:"VN"},
    {name:"Virgin Islands (British)", value:"VG"},
    {name:"Virgin Islands (U.S.)", value:"VI"},
    {name:"Wallis and Futuna", value:"WF"},
    {name:"Western Sahara*", value:"EH"},
    {name:"Yemen", value:"YE"},
    {name:"Zambia", value:"ZM"},
    {name:"Zimbabwe", value:"ZW"},
  ]

  public static FUZZINESS_TOOLTIP = $localize`“Exact match” allows no variation. Higher percentages allow looser matches and misspellings.`;

  public static FUZZINESSOPTIONS = [
      { value: "Exact match", key: "exact_match" },
      { value: "0%", key: "0" },
      { value: "10%", key: "0.1" },
      { value: "20%", key: "0.2" },
      { value: "30%", key: "0.3" },
      { value: "40%", key: "0.4" },
      { value: "50%", key: "0.5" },
      { value: "60%", key: "0.6" },
      { value: "70%", key: "0.7" },
      { value: "80%", key: "0.8" },
      { value: "90%", key: "0.9" },
      { value: "100%", key: "1" },
  ]

  public static AML_COUNTRY_PLACEHOLDER = $localize`Select one or more countries`

  public static DEFAULT_OPT_IN_QUESTION: string = `The organisation requesting this feedback, {{organisation}}, may in the future want to contact you in relation to potential employment opportunities. Do you consent to being contacted?`;
  public static BIRTH_YEAR_PLACEHOLDER = $localize`Select year of birth`

  public static MAX_REPORTS_PER_DAY = 25;

  public static PRODUCT_TOGGLE = {
      reference: {mainText: $localize`Reference`, subText: $localize`Candidates`},
      pulse: {mainText: $localize`Pulse`, subText: $localize`Employees`},
      exit: {mainText: $localize`Exit`, subText: $localize`Ex-employees`},
      backgroundCheck: {mainText: $localize`Background check`, subText: $localize`All people`},

  }

  public static PULSE_AI_SUMMARY_CHANNEL_NAMESPACE: string = 'pulse-ai-summary';

}
